import { RootState } from 'app/store';

export const selectEarlyContractTerminationLoading = (state: RootState) =>
  state.newRequest.earlyContractTerminationLoading;

export const selectEarlyContractTerminationError = (state: RootState) =>
  state.newRequest.earlyContractTerminationError;

export const selectEarlyContractTerminationSuccess = (state: RootState) =>
  state.newRequest.earlyContractTerminationSuccess;

export const selectDocumentsLoading = (state: RootState) =>
  state.newRequest.documentsLoading;

export const selectDocuments = (state: RootState) => state.newRequest.documents;

export const selectDocumentsError = (state: RootState) =>
  state.newRequest.documentsError;
